import { useFormik } from 'formik'
import * as Yup from 'yup'
import styles from './AccountsTable.module.css'

// Validation Schema
const validationSchema = Yup.object().shape({
  max_student: Yup.number().required('Required').min(1, 'Must be at least 1').integer('Must be a whole number'),
  status: Yup.string().required('Required').oneOf(['Active', 'Deactivate'], 'Invalid status'),
  deactivation_date: Yup.date().required('Required', 'Deactivation Date is Required'),
})

const EditableRow = ({ row, onSave, onCancel, isSaving }) => {
  const handleSubmit = (values) => {
    onSave(row.id, values)
  }

  const formik = useFormik({
    initialValues: {
      max_student: row.max_student,
      status: row.status,
      deactivation_date: row.deactivation_date,
    },
    validationSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true,
  })

  return (
    <tr className={styles.tableBodyRow}>
      <td className={styles.td}>{row.id}</td>
      <td className={styles.td}>{row.username}</td>
      <td className={styles.td}>
        <div>
          <input
            type='number'
            name='max_student'
            value={formik.values.max_student}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className={`${styles.input} ${
              formik.touched.max_student && formik.errors.max_student ? styles.errorInput : ''
            }`}
            min='1'
          />
          {formik.touched.max_student && formik.errors.max_student && (
            <div className={styles.error}>{formik.errors.max_student}</div>
          )}
        </div>
      </td>
      <td className={styles.td}>
        <div>
          <select
            className={`${styles.select} ${formik.touched.status && formik.errors.status ? styles.errorInput : ''}`}
            name='status'
            value={formik.values.status}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            disabled={isSaving}
          >
            <option value=''>Select Status</option>
            <option value='Active'>Active</option>
            <option value='Deactivate'>Deactivate</option>
          </select>
          {formik.touched.status && formik.errors.status && <div className={styles.error}>{formik.errors.status}</div>}
        </div>
      </td>
      <td className={styles.td}>
        <div>
          <input
            type='date'
            name='deactivation_date'
            value={formik.values.deactivation_date}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className={`${styles.input} ${
              formik.touched.deactivation_date && formik.errors.deactivation_date ? styles.errorInput : ''
            }`}
          />
          {formik.touched.deactivation_date && formik.errors.deactivation_date && (
            <div className={styles.error}>{formik.errors.deactivation_date}</div>
          )}
        </div>
      </td>
      <td className={styles.td}>
        <button
          type='button'
          onClick={formik.handleSubmit}
          className={styles.saveBtn}
          disabled={isSaving || !formik.isValid || !formik.dirty}
        >
          {isSaving ? (
            <span className={styles.loadingIndicator}>
              <span>.</span>
              <span>.</span>
              <span>.</span>
            </span>
          ) : (
            'Save'
          )}
        </button>
        <button type='button' onClick={onCancel} className={styles.cancelBtn} disabled={isSaving}>
          Cancel
        </button>
      </td>
    </tr>
  )
}

export default EditableRow
